import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ListaCadastroExcel(cadastros) {
  // Título
  const titulo = [["Relatório de Cadastros"]];

  // Cabeçalho
  const cabecalho = [["Código", "Nome", "CPF/CNPJ"]];

  // Dados formatados
  const dados = cadastros.map(cadastro => [
    cadastro.COD_CADASTRO,
    cadastro.RAZAO,
    cadastro.CNPJ
  ]);

  // Monta planilha final: título, linha vazia, cabeçalho, dados
  const planilhaCompleta = [...titulo, [], ...cabecalho, ...dados];

  // Cria a worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(planilhaCompleta);

  // Define largura das colunas
  worksheet["!cols"] = [
    { wch: 15 },  // Código
    { wch: 40 },  // Nome
    { wch: 25 },  // CPF/CNPJ
  ];

  // Cria o workbook e adiciona a planilha
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Cadastros");

  // Converte o workbook em array buffer
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });

  // Salva o arquivo
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  saveAs(blob, "Relatorio_Cadastros.xlsx");
}

export default ListaCadastroExcel;
